import { AxiosError, isAxiosError, type AxiosResponse } from 'axios';
import HttpClient from '../HttpClient';

class Status {
  private httpBokaCustomer: HttpClient;

  public constructor(httpBokaCustomer: HttpClient) {
    this.httpBokaCustomer = httpBokaCustomer;
  }

  public getStatus = async (): Promise<
    AxiosResponse<string> | AxiosError | Partial<AxiosError>
  > => {
    try {
      return await this.httpBokaCustomer.get<string>('/greeting');
    } catch (error) {
      if (isAxiosError(error)) {
        return error;
      }
      return {
        status: 500,
        statusText: 'Unknown Error',
      };
    }
  };
}

export default Status;
